<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';

  export default {
    components: { checkbox },
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        estados: estados,
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      observacaoItemCompraContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ? 
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      }
    }
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                    <label class="control-label" for="descricao-material">Descrição do material/serviço</label>

                    <textarea class="form-control"
                              id="descricao-material"
                              v-model="itemSolicitacao.descricao"
                              v-validate="'required'"
                              data-vv-name="descricaoMaterial"
                              data-vv-as="descrição do material/serviço">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="'required|not_zero'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>

            <div class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <h3 class="m-t m-b">Repesentante no Brasil</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="nome-empresa">Nome da empresa</label>

                    <input type="text"
                           class="form-control"
                           id="nome-empresa"
                           v-model="itemSolicitacao.nomeEmpresa"
                           maxlength="100">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="responsavel">Responsável</label>

                    <input type="text"
                           class="form-control"
                           id="responsavel"
                           v-model="itemSolicitacao.responsavel"
                           maxlength="100">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="email-responsavel">E-mail</label>

                    <input type="text"
                           class="form-control"
                           id="email-responsavel"
                           v-validate="`emailcomposto`"
                           v-model="itemSolicitacao.emailResponsavel"
                           maxlength="100">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="telefone-responsavel">Telefone</label>

                    <input type="text"
                           class="form-control"
                           id="telefone-responsavel"
                           v-model="itemSolicitacao.telefoneResponsavel"
                           v-mascara="'telefone'">
                </div>
            </div>
        </div>

        <h3 class="m-t m-b">Exportador/Representando no Exterior</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label" for="nome-exportador">Nome da empresa</label>

                    <input type="text"
                           class="form-control"
                           id="nome-exportador"
                           v-model="itemSolicitacao.nomeExportador"
                           maxlength="100">
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label" for="responsavel-exportador">Responsável</label>

                    <input type="text"
                           class="form-control"
                           id="responsavel-exportador"
                           v-model="itemSolicitacao.responsavelExportador"
                           maxlength="100">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="email-exportador">E-mail</label>

                    <input type="text"
                           class="form-control"
                           id="email-exportador"
                           v-validate="`emailcomposto`"
                           v-model="itemSolicitacao.emailExportador"
                           maxlength="100">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="telefone-exportador">Telefone</label>

                    <input type="text"
                           class="form-control"
                           id="telefone-exportador"
                           v-model="itemSolicitacao.telefoneExportador"
                           v-mascara="'telefone'">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label" for="proforma-invoice">Proforma Invoice Nº</label>

                    <input type="text"
                           class="form-control"
                           id="proforma-invoice"
                           v-model="itemSolicitacao.proformaInvoice"
                           maxlength="50">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group" :class="{'has-error': errors.has('vencProformaInvoice')}">
                    <label class="control-label" for="venc-proforma-invoice">Venc. da Proforma Invoice</label>

                    <input type="text"
                           class="form-control"
                           id="venc-proforma-invoice"
                           v-mascara="'data'"
                           placeholder="    /    /"
                           v-validate="'date_format:DD/MM/YYYY'"
                           data-vv-name="vencProformaInvoice"
                           data-vv-as="venc. da proforma invoice"
                           v-model="itemSolicitacao.vencProformaInvoice">

                    <p class="text-danger" v-show="errors.has('vencProformaInvoice')">{{ errors.first('vencProformaInvoice') }}</p>
                </div>

            </div>
        </div>

        <h3 class="m-t m-b">Elemento de Despesa</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.despesaCapital" value="1" type="success">
                            Despesa de Capital
                        </checkbox>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox v-model="itemSolicitacao.materialConsumo" value="1" type="success">
                            Material de Consumo
                        </checkbox>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label" for="outros">Outros</label>

                    <input type="text"
                           class="form-control"
                           id="outros"
                           v-model="itemSolicitacao.outros">
                </div>
            </div>
        </div>

        <h3 class="m-t m-b">Local que o material será alocado</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-sm-3">
                <div class="form-group" :class="{'has-error': errors.has('ceplocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
                    <label class="control-label" for="cep-local-alocado">CEP</label>

                    <input type="text"
                           class="form-control"
                           id="cep-local-alocado"
                           data-vv-name="ceplocalAlocado"
                           data-vv-as="cep"
                           v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                           v-model="itemSolicitacao.cepLocalAlocado"
                           v-mascara="'cep'">

                    <p class="text-danger" v-show="errors.has('ceplocalAlocado')">{{ errors.first('ceplocalAlocado') }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group" :class="{'has-error': errors.has('enderecolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
                    <label class="control-label" for="endereco-local-alocado">Endereço</label>

                    <input type="text"
                           class="form-control"
                           id="endereco-local-alocado"
                           v-model="itemSolicitacao.enderecoLocalAlocado"
                           data-vv-name="enderecolocalAlocado"
                           data-vv-as="endereço"
                           v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                           maxlength="60">

                    <p class="text-danger" v-show="errors.has('enderecolocalAlocado')">{{ errors.first('enderecolocalAlocado') }}</p>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group" :class="{'has-error': errors.has('numerolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
                    <label class="control-label" for="numero-local-alocado">Número</label>

                    <input type="text"
                           class="form-control"
                           id="numero-local-alocado"
                           v-model="itemSolicitacao.numeroLocalAlocado"
                           data-vv-name="numerolocalAlocado"
                           data-vv-as="número"
                           v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('numerolocalAlocado')">{{ errors.first('numerolocalAlocado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-2">
                <div class="form-group">
                    <label class="control-label" for="complemento-local-alocado">Complemento</label>

                    <input type="text"
                           class="form-control"
                           id="complemento-local-alocado"
                           v-model="itemSolicitacao.complementoLocalAlocado"
                           data-vv-name="complementolocalAlocado"
                           data-vv-as="complemento"
                           maxlength="30">

                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('bairrolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
                    <label class="control-label" for="bairro-local-alocado">Bairro</label>

                    <input type="text"
                           class="form-control"
                           id="bairro-local-alocado"
                           v-model="itemSolicitacao.bairroLocalAlocado"
                           data-vv-name="bairrolocalAlocado"
                           data-vv-as="bairro"
                           v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                           maxlength="40">

                    <p class="text-danger" v-show="errors.has('bairrolocalAlocado')">{{ errors.first('bairrolocalAlocado') }}</p>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('cidadelocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
                    <label class="control-label" for="cidade-local-alocado">Cidade</label>

                    <input type="text"
                           class="form-control"
                           id="cidade-local-alocado"
                           v-model="itemSolicitacao.cidadeLocalAlocado"
                           data-vv-name="cidadelocalAlocado"
                           data-vv-as="cidade"
                           v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                           maxlength="40">

                    <p class="text-danger" v-show="errors.has('cidadelocalAlocado')">{{ errors.first('cidadelocalAlocado') }}</p>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group" :class="{'has-error': errors.has('estadolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolCompras}">
                    <label class="control-label" for="estado-local-alocado">Estado</label>

                    <select class="form-control"
                            id="estado-local-alocado"
                            data-vv-name="estadolocalAlocado"
                            data-vv-as="estado"
                            v-validate="`${configuracao.obrigatorioLocalAlocadoSolCompras ? 'required' : ''}`"
                            v-model="itemSolicitacao.estadoLocalAlocado">
                        <option value="" selected>Selecione...</option>
                        <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
                    </select>

                    <p class="text-danger" v-show="errors.has('estadolocalAlocado')">{{ errors.first('estadolocalAlocado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-8">
                <div class="form-group" :class="{'has-error': errors.has('unidadelocalAlocado'), 'required': configuracao.obrigatorioUnidadeInstituicao}">
                    <label class="control-label" for="unidade-local-alocado">Unidade</label>

                    <input type="text"
                           class="form-control"
                           id="unidade-local-alocado"
                           data-vv-name="unidadelocalAlocado"
                           data-vv-as="unidade"
                           v-validate="`${configuracao.obrigatorioUnidadeInstituicao ? 'required' : ''}`"
                           v-model="itemSolicitacao.unidadeLocalAlocado"
                           maxlength="40">

                    <p class="text-danger" v-show="errors.has('unidadelocalAlocado')">{{ errors.first('unidadelocalAlocado') }}</p>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('cnpjUnidadeLocalAlocado'), 'required': configuracao.obrigatorioCNPJUnidadeInstituicao}">
                    <label class="control-label" for="cnpj-unidade-local-alocado">CNPJ Unidade</label>

                    <input type="text"
                           class="form-control"
                           id="cnpj-unidade-local-alocado"
                           v-mascara="'cnpj'"
                           v-model="itemSolicitacao.cnpjUnidadeLocalAlocado"
                           data-vv-as="cnpj unidade"
                           data-vv-name="cnpjUnidadeLocalAlocado"
                           v-validate="`${configuracao.obrigatorioCNPJUnidadeInstituicao ? 'required|cnpj' : 'cnpj'}`">

                    <p class="text-danger" v-show="errors.has('cnpjUnidadeLocalAlocado')">{{ errors.first('cnpjUnidadeLocalAlocado') }}</p>
                </div>
            </div>
        </div>

        <div class="hr-line-dashed"></div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de compra ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormImportacao.vue